import * as Highcharts from 'highcharts';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '@/utils/constants';
import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

interface IObtainedFundsProps {
    submissions: any[];
}

const transform = [
    {text: 'Family & friends', value: 'question26'},
    {text: 'Business Angels', value: 'question2'},
    {text: 'Crowdfunding', value: 'question27'},
    {text: 'Incubators and Accelerators', value: 'question35'},
    {text: 'NGO\u2019s loans', value: 'question40'},
    {text: 'NGO’s grants', value: 'question45'},
    {text: 'Public subsidies (e.g. tax credits)', value: 'question50'},
    {text: 'Venture capital', value: 'question60'},
    {text: 'Microfinance', value: 'question65'},
    {text: 'Financial institutions (banks)', value: 'question70'},
    {text: 'Other', value: 'question75'},
]

const PieObtainedFunds = ({submissions}: IObtainedFundsProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        let success: number = 0;
        let unSuccess: number = 0;
        let pending: number = 0;

        Object.values(transform).forEach((item) => {
            success += submissions.filter((submission: any) => submission[item.value] === 'item1').length;
            unSuccess += submissions.filter((submission: any) => submission[item.value] === 'item3').length;
            pending += submissions.filter((submission: any) => submission[item.value] === 'item2').length;
        });

        const data = [
            {
                name: 'Yes',
                y: success,
                color: COLORS.blue,
            },
            {
                name: 'No',
                y: unSuccess,
                color: COLORS.gray,
            },
            {
                name: 'Pending',
                y: pending,
                color: COLORS.orange,
            }
        ];

        const dashboardOptions: any = getDefaultPieFormatting(
            '% of entrepreneurs who obtained the funds',
            data,
            1,
            {},
        );
        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default PieObtainedFunds;
